import script from "./roleIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./roleIndex.vue?vue&type=script&setup=true&lang=js"

import "./roleIndex.vue?vue&type=style&index=0&id=63c9856c&lang=scss"

const __exports__ = script;

export default __exports__